import React from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem } from '@mui/material'

export const CommonMenu = ({
  id = 'common-menu',
  anchorEl,
  open,
  onClose,
  items = [],
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  transformOrigin = { vertical: 'top', horizontal: 'right' },
  ...props
}) => {
  const handleItemClick = onClick => () => {
    if (typeof onClick === 'function') {
      onClick()
    }
    if (typeof onClose === 'function') {
      onClose()
    }
  }

  return (
    <Menu
      id={id}
      data-testid={id}
      anchorEl={anchorEl}
      open={Boolean(open)}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      {...props}
    >
      {items.map((item, index) => {
        const Component = item.component || (item.href ? 'a' : undefined)
        return (
          <MenuItem
            key={item.key || `${id}-item-${index}`}
            component={Component}
            href={item.href}
            target={item.target}
            rel={item.rel}
            onClick={handleItemClick(item.onClick)}
          >
            {item.label}
          </MenuItem>
        )
      })}
    </Menu>
  )
}

CommonMenu.propTypes = {
  id: PropTypes.string,
  anchorEl: PropTypes.any,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func,
      href: PropTypes.string,
      target: PropTypes.string,
      rel: PropTypes.string,
      component: PropTypes.any,
      key: PropTypes.string,
    })
  ),
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.oneOfType([
      PropTypes.oneOf(['top', 'bottom', 'center']),
      PropTypes.number,
    ]),
    horizontal: PropTypes.oneOfType([
      PropTypes.oneOf(['left', 'right', 'center']),
      PropTypes.number,
    ]),
  }),
  transformOrigin: PropTypes.shape({
    vertical: PropTypes.oneOfType([
      PropTypes.oneOf(['top', 'bottom', 'center']),
      PropTypes.number,
    ]),
    horizontal: PropTypes.oneOfType([
      PropTypes.oneOf(['left', 'right', 'center']),
      PropTypes.number,
    ]),
  }),
}
